export default __webpack_public_path__ + "static/media/sofa-3-seat-1-back.7d1ef165.webp";